import React from 'react'
import { View } from 'react-native'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTheme } from '@react-navigation/native'
import { FullRegistrationData, Step2Data } from '@hooks'
import { Button, OnBoarding } from '@components'
import { useLanguage } from '@context'
import { Step2ValidationSchema } from './schema'
import getStyle from './style'
import { StepTitle } from '../components'
import { FormHashtagList } from '@components'

export const Step2Form = ({
  onSubmit,
}: {
  onSubmit: (newData: Partial<FullRegistrationData>) => void
}) => {
  const { t } = useLanguage()

  const theme = useTheme()
  const styles = getStyle(theme)

  const { control, handleSubmit, clearErrors, watch, setValue } = useForm<Step2Data>({
    defaultValues: {
      hashtags: [],
    },
    resolver: yupResolver(Step2ValidationSchema),
  })

  const hashtagsValue = watch('hashtags')

  const handleAddHashtag = (value: string[]) => {
    setValue('hashtags', value)
    clearErrors('hashtags')
  }

  const handleRemoveHashtag = (value: string[]) => setValue('hashtags', value)

  return (
    <View style={styles.container}>
      <OnBoarding>
        <StepTitle
          mainTitle={t('registerStepHastags.mainTitle')}
          subtitle={t('registerStepHastags.title')}
        />
        
        <FormHashtagList
          control={control}
          name="hashtags"
          values={hashtagsValue}
          addItem={handleAddHashtag}
          removeItem={handleRemoveHashtag}
        />

        <Button
          title={t('registerStepHastags.next')}
          onPress={handleSubmit(onSubmit)}
          containerStyle={styles.button}
        />
      </OnBoarding>
    </View>
  )
}
